module.exports = __webpack_public_path__ + "static/media/bubble_12.8c4ac17d.jpg";